<template lang="pug">
    div.page
        div.imglist
            el-carousel(:interval="4000" type="card" @change="change" height="400px" :autoplay="autoPlay")
                el-carousel-item(v-for="(item, index) in imgList" :key="item")
                    img.img(:src="item" :ref="'img' + index" crossOrigin="")
                    span.result-text(v-if="result[index]") {{ result[index] }}

        el-button(type="primary" @click="predict").predict 点击识别此图

        div.loading(v-if="isLoading || isPredicting")
            span.loading-text {{ isLoading ? 'loading...' : '识别中……'}}



</template>

<script>
import 'regenerator-runtime/runtime';
import map from './data/wine.map.json';
import * as mobilenet from '@paddlejs-models/mobilenet';
import { sendShowLog, sendClickLog } from '@/common/js/log';

export default {
    data() {
        return {
            imgList: [
                require('./imgs/1.jpg'),
                require('./imgs/2.jpg'),
                require('./imgs/3.jpg'),
                require('./imgs/4.jpg'),
                require('./imgs/5.jpg'),
                require('./imgs/6.jpg'),
                require('./imgs/7.jpg')
            ],
            result: {},
            curImgIndex: 0,
            autoPlay: true,
            isLoading: true,
            isPredicting: false
        }
    },
    methods: {
        change(index) {
            this.curImgIndex = index;
        },
        async predict() {
            this.autoPlay = false;
            this.isPredicting = true;
            const curIndex = this.curImgIndex;
            const imgDom = this.$refs['img' + this.curImgIndex][0];
            await this.predictModel(imgDom, curIndex);
            this.isPredicting = false;
            sendClickLog('pdjs_wine', 'predict');
        },
        async load() {
            const path = 'https://paddlejs.bj.bcebos.com/models/fuse/mobilenet/wine_fuse_activation/model.json';
            await mobilenet.load({
                path,
                mean: [0.485, 0.456, 0.406],
                std: [0.229, 0.224, 0.225]
            }, map);
            this.isLoading = false;
        },
        async predictModel(img, curIndex) {
            const res = await mobilenet.classify(img);
            this.result[curIndex] = res || '无结果';
        }
    },
    mounted() {
        this.load();
        sendShowLog('pdjs_wine');
    }
}
</script>

<style scoped>
.page {
    max-width: 800px;
    padding-top: 50px;
    text-align: center;
    margin: 0 auto;
}
.img {
    display: block;
    width: 100%;
    height: 380px;
}
.loading {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .7);
    color: #fff;
    z-index: 2;
    font-size: 32px;
}
.imglist {
    margin-bottom: 0;
}
.result-text {
    font-weight: bold;
}
</style>
